(() => {
  if (!window.customElements || customElements.get('shipping-progress')) return;
  customElements.define('shipping-progress', class extends HTMLElement {
    connectedCallback() {
      this.updateProgress();
      if (!this.dataset.converted) window.addEventListener('load', () => this.updateProgress(), { once: true });
    }
    updateProgress() {
      const message = this.querySelector('[data-converted-message]');
      const progress = this.querySelector('[data-converted-progress]');
      if (!message || !progress) return;
      const currency = window.Shopify?.currency;
      const rate = Number(currency?.rate);
      const threshold = Number(this.dataset.threshold);
      const subtotal = Number(this.dataset.subtotal);
      const code = this.dataset.cartCurrency;
      // Shopify's storefront rate converts the shop currency to the active currency.
      // It is an estimate: checkout can apply fees, rounding and other conditions.
      if (this.dataset.ruleCurrency !== this.dataset.shopCurrency || currency?.active !== code ||
          !Number.isFinite(rate) || rate <= 0 || !Number.isFinite(threshold) || threshold <= 0 ||
          !Number.isFinite(subtotal) || subtotal < 0 || !/^[A-Z]{3}$/.test(code)) return;
      const digits = new Intl.NumberFormat('en', { style: 'currency', currency: code }).resolvedOptions().maximumFractionDigits;
      // Shopify represents even zero-decimal currencies in units multiplied by 100.
      const step = 100 / (10 ** digits);
      const converted = Math.ceil(threshold * rate / step) * step;
      if (!Number.isFinite(converted) || converted <= 0) return;
      const remaining = Math.max(0, converted - subtotal);
      const amount = new Intl.NumberFormat('en', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(remaining / 100);
      if (remaining > 0) {
        const strong = document.createElement('strong');
        strong.textContent = `${amount} ${code}`;
        message.replaceChildren('Add about ', strong, ' more for free shipping.');
      } else {
        message.textContent = 'Estimated free-shipping minimum reached.';
      }
      progress.max = converted;
      progress.value = Math.min(subtotal, converted);
      progress.hidden = false;
      this.dataset.converted = 'true';
      const note = this.querySelector('[data-conversion-note]');
      if (note && !note.dataset.updated) {
        note.textContent = note.textContent.replace('Minimum ', 'Estimated from ');
        note.dataset.updated = 'true';
      }
    }
  });
})();
